import classnames from "classnames";
import TYPE_RESSOURCE from "../../enum/TypeRessource.tsx";
import Button from "../Button/Button.tsx";
import {
  IconCheck,
  IconCross,
  IconDelete,
  IconEdit,
  IconOverview,
} from "../Icon/Icon.tsx";
import ConfirmModal from "../Modal/ConfirmModal.tsx";
import DeleteModal from "../Modal/DeleteModal.tsx";
import { useModal } from "../Modal/Modal.tsx";
import PreviewRessourceModal from "../Modal/PreviewRessourceModal.tsx";
import styles from "./columns.module.css";

const EditColumn = ({
  to,
  canEdit = false,
  canEditFunction,
  title = true,
  ...option
}: EditColumnType) => ({
  // eslint-disable-next-line react/display-name
  Cell: (row: any) => {
    const canEditValue = canEditFunction ? canEditFunction(row.value) : canEdit;
    return (
      <>
        {canEditValue && (
          <a href={to(row.value)} className={styles.link}>
            <IconEdit />
            {title && <>&nbsp;Modifier</>}
          </a>
        )}
      </>
    );
  },
  width: title ? 140 : 90,
  ...option,
});

export default EditColumn;

type EditColumnType = {
  to: (id: string) => any;
  title?: boolean;
  accessor: string;
  canEdit?: boolean;
  canEditFunction?: (t: any) => boolean;
};

export const DeleteColumn = ({
  path,
  reload,
  title = true,
  canSuppress = false,
  canSuppressFunction,
  header,
  content,
  ...options
}: DeleteColumnType) => ({
  // eslint-disable-next-line react/display-name
  Cell: (row) => {
    const { visible, show, close } = useModal();
    const query = `${path}${row.value}`;
    const canSuppressValue = canSuppressFunction
      ? canSuppressFunction(row.value)
      : canSuppress;
    return (
      <>
        {canSuppressValue && (
          <>
            <Button
              onClick={show}
              className={classnames(styles.cellButton, styles.deleteCell)}
            >
              <IconDelete />
              {title && <>&nbsp;Supprimer</>}
            </Button>
            <DeleteModal
              visible={visible}
              closeModal={close}
              header={header}
              content={content}
              query={query}
              onDelete={() => (reload ? reload() : window.location.reload())}
            />
          </>
        )}
      </>
    );
  },
  width: title ? 160 : 90,
  ...options,
});

type DeleteColumnType = {
  path: object;
  id: string;
  title?: boolean;
  header: string | undefined;
  content: string | undefined;
  reload?: () => void;
  canSuppress: boolean;
  canSuppressFunction: (t: any) => boolean;
};

export const ActiveDesactiveColumn = ({
  path,
  reload,
  title = true,
  canDesactive = false,
  canDesactiveFunction,
  headerActif,
  contentActif,
  headerInactif,
  contentInactif,
  ...options
}: DesactiveColumnType) => ({
  // eslint-disable-next-line react/display-name
  Cell: (row) => {
    const { visible, show, close } = useModal();
    const query = `${path}${row.value}`;
    const canDesactiveValue = canDesactiveFunction
      ? canDesactiveFunction(row.value)
      : canDesactive;

    const active = row.original.actif;
    return (
      <>
        {canDesactiveValue && (
          <>
            <Button
              onClick={show}
              className={
                active
                  ? classnames(styles.cellButton, styles.deleteCell)
                  : classnames(styles.cellButton, styles.activeCell)
              }
            >
              {!active ? <IconCheck /> : <IconCross />}
              {title && <>&nbsp;{!active ? "Activer" : "Désactiver"}</>}
            </Button>
            <ConfirmModal
              visible={visible}
              closeModal={close}
              header={active ? headerActif : headerInactif}
              content={active ? contentActif : contentInactif}
              query={query}
              onConfirm={() => (reload ? reload() : window.location.reload())}
            />
          </>
        )}
      </>
    );
  },
  width: title ? 160 : 90,
  ...options,
});

type DesactiveColumnType = {
  path: object;
  id: string;
  title?: boolean;
  active: boolean;
  reload?: () => void;
  canDesactive: boolean;
  canDesactiveFunction: (t: any) => boolean;
};

export const PreviewColumn = ({
  ressourceCode,
  ressourceType,
  ressourcePrivee,
}: PreviewColumnType) => {
  // eslint-disable-next-line react/display-name
  const { visible, show, close } = useModal();
  return (
    <>
      <Button
        onClick={show}
        className={classnames(styles.cellButton, styles.previewCell)}
      >
        <IconOverview />
      </Button>
      <PreviewRessourceModal
        visible={visible}
        closeModal={close}
        ressourceCode={ressourceCode}
        ressourceType={ressourceType}
        ressourcePrivee={ressourcePrivee}
      />
    </>
  );
};
type PreviewColumnType = {
  ressourceCode: string;
  ressourceType: TYPE_RESSOURCE;
  ressourcePrivee: boolean;
};
